import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  podcast: [],
  inHouseList: [],
  inHousePlaylist: [],
  inHouseFavList: [],
  podcastPlaylist: [],
  podcastFavList: [],
  selectedInhouse: {},
  selectedPodcast: {},
  trendingPodcasts: [],
  mostViewedPodcasts: [],
  searchResults: [],
  tagSearch: "",
};

const mediaSlice = createSlice({
  name: "media",
  initialState: initialState,
  reducers: {
    getPodcast(state, payload) {
      state.podcast = payload.payload.response;
    },
    getInHouseList(state, payload) {
      state.inHouseList = payload.payload.response;
    },
    setSelectedInHouse(state, payload) {
      state.selectedInhouse = payload.payload;
    },
    setSelectedPodcast(state, payload) {
      state.selectedPodcast = payload.payload;
    },
    getInHouseFavList(state, payload) {
      state.inHouseFavList = payload.payload.response;
    },
    getTrendingPodcasts(state, payload) {
      state.trendingPodcasts = payload.payload.response;
    },
    getMostViewedPodcasts(state, payload) {
      state.mostViewedPodcasts = payload.payload.response;
    },
    getInHousePlaylist(state, payload) {
      state.inHousePlaylist = payload.payload.response;
    },
    getPodcastFavList(state, payload) {
      state.podcastFavList = payload.payload.response;
    },
    getPodcastPlaylist(state, payload) {
      state.podcastPlaylist = payload.payload.response;
    },
    getTagSearch(state, payload) {
      state.tagSearch = payload.payload.response;
    },
    setSearchResults(state, payload) {
      state.searchResults = payload.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
    reset(state, action) {
      state.selectedInhouse = {};
      state.selectedPodcast = {};
    },
    resetUnit(state, action) {
      if (action.payload.type === "inhouse") state.inHouseList = [];
      else state.podcast = [];
    },
  },
});

export default mediaSlice.reducer;
export const mediaActions = mediaSlice.actions;
